import logger from "logging/logger";
import useEnterLeaveEvent from "modules/event/hooks/useEnterLeaveEvent";
import { selectCurrentEventCode } from "modules/event/selectors";
import { useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

export const useConnectionAttempts = (maxAttempts: number) => {
  const { leaveEvent } = useEnterLeaveEvent();
  const eventCode = useSelector(selectCurrentEventCode);
  const history = useHistory();
  const connectionAttempts = useRef(0);

  const disconnect = useCallback(() => {
    leaveEvent();
    history.push(`/e/${eventCode}/register`);
  }, [leaveEvent, history, eventCode]);

  const resetConnectionAttempts = useCallback(() => {
    connectionAttempts.current = 0;
  }, []);

  const incrementConnectionAttempts = useCallback(() => {
    connectionAttempts.current += 1;
    logger.info(
      `[userPresence]: connection attempt ${connectionAttempts.current}`,
    );
    if (connectionAttempts.current >= maxAttempts) {
      disconnect();
    }
  }, [disconnect, maxAttempts]);

  return { disconnect, resetConnectionAttempts, incrementConnectionAttempts };
};
